import $ from "jquery";
import Photoswipe from "photoswipe";
import PhotoSwipeUI_Default from "photoswipe/dist/photoswipe-ui-default";
import getParameterByName from "../../utils/getParameterByName";
import templateString from "./photoSwipeTemplate";
import sortBy from "lodash/sortBy";

export default () => {
    let $images = [];
    let images = [];
    let template = '';

    const init = ($galleryItems) => {
        $images = $galleryItems;
        const imgs = $.map($galleryItems, (el, index) => {
            const data = $(el).data();
            return {
                index,
                msrc: data.thumbnail,
                src: data.src,
                w: data.width,
                h: data.height,
            };
        });

        images = sortBy(imgs, 'index');
        template = $(templateString).appendTo($('body'))[0];
    };

    const initGallery = function (images, index = 0, galleryUID = 0) {

        const gallery = new Photoswipe(template, PhotoSwipeUI_Default, images, {
            index,
            galleryUID,
            closeOnScroll: false,
            showHideOpacity: false,
            showAnimationDuration: 0
        });

        return gallery.init();
    };

    const galleryItemOnClick = function (e) {
        if (!$(e.target).is('img, a')) {
            return;
        }

        e.preventDefault();
        const data = $(this).data();
        initGallery(images, data.index, data.galleryIndex);
    };

    const documentOnReady = function () {
        const pid = getParameterByName('pid');

        if (pid === null) {
            return;
        }

        initGallery(images, pid);
    };

    const run = () => {
        $images.on('click', galleryItemOnClick);
        $(window).on('load', documentOnReady);
    };

    return {
        init,
        run
    };
};


// WEBPACK FOOTER //
// ./src/js/modules/photoswipe/photoswipeGallery.js